import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import BRANDING from "../config/branding";
import { API_URL } from '../config/api';

const SendSmsPage = () => {
	const [msisdn, setMsisdn] = useState("");
	const [text, setText] = useState("");
	const [groupId, setGroupId] = useState(""); // Added group ID state
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const navigate = useNavigate();
	const [groups, setGroups] = useState([]);

	



	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setError(null);

		try {
			const token = localStorage.getItem("token");

			const response = await axios.post(
				`${API_URL}/sms_gateway.php`, //  Endpoint
				{ msisdn, text, group_id: groupId }, // Include group_id
				{
					headers: {
						Authorization: `Bearer ${token}`,
						"Content-Type": "application/json",
					},
				}
			);

			if (
    ["complete", "success", true].includes(
        response.data.status
    )
) {
    navigate("/dashboard");
} else {
    setError(
        response.data.message ||
        "Failed to send SMS"
    );
}
		} catch (err) {
			setError(err.message || "Something went wrong. Please try again.");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		const fetchGroups = async () => {
			try {
				const token = localStorage.getItem("token");
				const response = await axios.get(
					"https://bulksms.approot.ng//list_groups.php",
					{
						headers: {
							Authorization: `Bearer ${token}`,
						},
					}
				);

				if (response.data.status) {
					setGroups(response.data.groups);
				} else {
					setError(response.data.message || "Failed to load groups.");
				}
			} catch (err) {
				setError("Error loading groups.");
			}
		};

		fetchGroups();
	}, []);

	return (
		<div className='min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 to-white px-4'>
			<div className='w-full max-w-lg bg-white p-8 rounded-lg shadow-md'>
				<div className='flex justify-center mb-6'>
	<img
		src={BRANDING.logo}
		alt={BRANDING.shortName}
		className='h-16 w-auto object-contain'
	/>
</div>
				<h2
	className='text-2xl font-bold text-center mb-2'
	style={{ color: BRANDING.primaryColor }}
>
	Send SMS
</h2>

<p className='text-center text-gray-500 mb-6'>
	Send a single SMS message through the RedPay platform
</p>

				{error && (
					<div className='mb-4 text-sm text-red-600 text-center border border-red-500 rounded-md p-2 bg-red-100'>
						<span className='font-semibold'>Error: </span>
						{error}
					</div>
				)}

				<form onSubmit={handleSubmit} className='space-y-4'>
					<div>
						<label
							htmlFor='msisdn'
							className='block text-sm font-medium text-gray-700'
						>
							MSISDN (Phone Number)
						</label>
						<input
							id='msisdn'
							type='text'
							value={msisdn}
							onChange={(e) => setMsisdn(e.target.value)}
							placeholder='e.g., 2348012345678'
							className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-red-600'
							required
						/>
					</div>
					<div>
						<label
							htmlFor='text'
							className='block text-sm font-medium text-gray-700'
						>
							Text Message
						</label>
						<textarea
							id='text'
							value={text}
							onChange={(e) => setText(e.target.value)}
							placeholder='Enter your SMS message here...'
							className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-red-600'
							rows={4}
							required
						/>
					</div>
					<div className='mb-4'>
						<label
							htmlFor='group_id'
							className='block text-sm font-medium text-gray-700'
						>
							Select SMS Group (Optional)
						</label>
						<select
							id='group_id'
							value={groupId}
							onChange={(e) => setGroupId(e.target.value)}
							className='mt-1 block w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-red-600 focus:border-red-600'
		
						>
							<option value=''>-- Select Group --</option>
							{groups.map((group) => (
								<option key={group.id} value={group.id}>
									{group.name}
								</option>
							))}
						</select>
					</div>

					<button
						type='submit'
						disabled={loading}
						className='w-full bg-red-600 text-white py-3 rounded-lg hover:bg-red-700 transition font-semibold disabled:opacity-50'
					>
						{loading ? "Sending..." : "Send SMS"}
					</button>
				</form>
			</div>
		</div>
	);
};

export default SendSmsPage;
